export const CHECKLIST = 'checklist';
export const WAITLIST = 'waitlist';
export const CONFIRMATION_EMAIL = 'confirmation_email';
export const POST_VISIT_SUMMARY = 'post_visit_summary';
export const THREE_DAY_CHECK_IN = 'three_day_check_in';
export const CHECKLIST_REMINDER = 'checklist_Reminder';
export const MONTHLY_INSURANCE_UPDATE_EMAIL = 'monthly_insurance_update_email';
